import { ENV_VARS, getSummerHost } from "../config/env";
import RouterConstants from "./RouterConstants";

const platformUrl = ENV_VARS.VITE_NEW_PLATFORM_URL;

class LinkConstants {
	public static readonly BRIA_WEBSITE: string = "https://bria.ai/";
	public static readonly LEGAL_LOBBY: string = "https://bria.ai/legal-lobby";
	public static readonly BRIA_API: string = "https://docs.bria.ai";

	// Platform / Console sidebar links (paths for same-origin / internal redirect)
	public static readonly PLATFORM = {
		API_CATALOG: `${platformUrl}/catalog`,
		BILLING: `${platformUrl}/billing`,
		FINETUNING: "/tailored-generation/overview",
		INTEGRATIONS: `${platformUrl}/integrations`,
		AGENTS: "/mcp",
		OPEN_SOURCE: "/models/overview",
		CONSUMPTION_BILLING: "/account/usage",
		WORKSPACE_SETTINGS: "/account/api-keys",
		WORKBENCH: `${platformUrl}/workbench`,
	};

	public static readonly BRIA_FIBO_EDIT_SANDBOX: string = `${platformUrl}/image-editing/fibo-image-edit/sandbox`;
	public static readonly BRIA_FIBO_SANDBOX: string = `${platformUrl}/image-generation/fibo-generate/sandbox`;
	public static readonly BRIA_FIBO_LITE_SANDBOX: string = `${platformUrl}/image-generation/fibo-lite-generate/sandbox`;
	public static readonly BRIA_REMOVE_BG_SANDBOX: string = `${platformUrl}/image-editing/remove-background/sandbox`;
	public static readonly BRIA_API_KEYS_PLATFORM_PAGE: string = `${platformUrl}/organization-management/api-keys`;

	public static readonly CONTENT_MODERATION_BRIA_API_DOC: string =
		"https://docs.bria.ai/safety#input--output-visual-moderation";
	public static readonly PROMPT_MODERATION_BRIA_API_DOC: string = "https://docs.bria.ai/safety#prompt-moderation";
	public static readonly IP_SIGNAL_BRIA_API_DOC: string = "https://docs.bria.ai/safety#handling-ip-related-prompts";
	public static readonly IFRAME_DOCS: string = "https://github.com/Bria-AI/iframe-doc";
	public static readonly IFRAME_v2_DOCS: string = "https://github.com/Bria-AI/iframe-doc/tree/iframe-v2";
	public static readonly CONTACT_US_FORM_LINK: string = "https://bria.ai/contact-us";
	public static readonly PRESENTER_RECASTING: string = `${getSummerHost()}/gallery/ade0c69399697896?selectedTab=presenters`;
	public static readonly STATUS_PAGE: string = "https://status.bria.ai/";
	public static readonly DISCORD_COMMUNITY: string = "https://discord.com/invite/Nxe9YW9zHS";
	public static readonly SLACK_API_COMMUNITY: string =
		"https://join.slack.com/t/briaapi/shared_invite/zt-2urw5ppmc-4K8hxWLQ1wYLvekB66zm7A";
	public static readonly BRIA_HUGGING_FACE: string = "https://huggingface.co/briaai";
	public static readonly BRIA_HUGGING_FACE_MODELS: string = "https://huggingface.co/briaai/models";
	public static readonly BRIA_AGENT: string = "https://github.com/Bria-AI/agent";
	public static readonly AI_EDITOR: string = `${getSummerHost()}/gallery/8679a552aa79cc96/?from_platform_hub=true&openUploadPopup=true`;
	public static readonly BRIA_IMAGES_URL: string = "https://images.bria.ai/";
	public static readonly BRIA_USER_ASSETS_CLOUDFRONT: string = "https://user-assets.bria.ai/";
	public static readonly BRIA_ORG_ASSETS_CLOUDFRONT: string = "https://org-assets.bria.ai/";
	public static readonly BRIA_AI_AWS_MARKETPLACE: string = `https://aws.amazon.com/marketplace/seller-profile?id=seller-ilfk2fw5juhfi`;
	public static readonly BRIA_AI_AZURE_MARKETPLACE: string =
		"https://azuremarketplace.microsoft.com/en-us/marketplace/apps/briaartificialintelligenceltd1704805814390.bria_image_generation_model_offer?tab=Overview";
	public static readonly BRIA_HF_PRODUCT_SHOT_GEN: string =
		"https://huggingface.co/spaces/briaai/Product-Shot-Generation";
	public static readonly BRIA_FAL_AI: string = "https://fal.ai/explore/search?q=bria";
	public static readonly REPLICATE: string = "https://replicate.com/bria";
	public static readonly INVOKE_PLATFORM: string = "https://www.invoke.com/";
	// ComfyUI
	public static readonly BRIA_COMFYUI_API: string = "https://github.com/Bria-AI/ComfyUI-BRIA-API";
	public static readonly BRIA_COMFYUI_TAILORED_GEN: string = `${this.BRIA_COMFYUI_API}/tree/main?tab=readme-ov-file#tailored-generation-nodes`;
	// Image Generation
	public static readonly BRIA_API_TEXT_TO_IMAGE: string = `${this.BRIA_API}/image-generation/endpoints/text-to-image-base`;
	public static readonly BRIA_API_TEXT_TO_VECTOR: string = `${this.BRIA_API}/image-generation/endpoints/text-to-vector-base`;
	public static readonly BRIA_API_IMAGE_REFERENCE: string = `${this.BRIA_API}/image-generation/endpoints/reimagine-structure-reference`;
	public static readonly BRIA_API_PROMPT_ENHANCE: string = `${this.BRIA_API}/image-generation/endpoints/prompt-enhancer`;
	// Tailored Generation
	public static readonly BRIA_API_TG: string = `${this.BRIA_API}/tailored-generation/image-generation/image-generate-tailored`;
	public static readonly BRIA_API_TG_GENERATE_IMAGES: string = `${this.BRIA_API}/tailored-generation/image-generation-endpoints`;
	public static readonly BRIA_API_TG_RESTYLE_PORTRAITS: string = `${this.BRIA_API}/tailored-generation/generation-endpoints/restyle-portrait`;
	public static readonly BRIA_API_TG_VIDEO_GENERATION: string = `${this.BRIA_API}/tailored-generation/video-generation-endpoints`;
	//  Image Editing
	public static readonly BRIA_API_REMOVE_OBJECT: string = `${this.BRIA_API}/image-editing/editing/erase`;
	public static readonly BRIA_API_BACKGROUND_REMOVE: string = `${this.BRIA_API}/image-editing/editing/background-remove`;
	public static readonly BRIA_API_BACKGROUND_GENERATION: string = `${this.BRIA_API}/image-editing/v2-endpoints/replace_background`;
	public static readonly BRIA_API_BACKGROUND_BLUR: string = `${this.BRIA_API}/image-editing/v2-endpoints/blur_background`;
	public static readonly BRIA_API_IMAGE_EXPANSTION: string = `${this.BRIA_API}/image-editing/editing/image-expansion`;
	public static readonly BRIA_API_INCREASE_RESOLUTION: string = `${this.BRIA_API}/image-editing/v2-endpoints/increase_resolution`;
	// Product Shot Editing
	public static readonly BRIA_API_TEXT_PROMPTS_LIFESTYLE: string = `${this.BRIA_API}/product-shot-editing/endpoints/product-lifestyle-shot-by-text`;
	public static readonly BRIA_API_LIFESTYLE_PRODUCT_SHOT_BY_IMAGE: string = `${this.BRIA_API}/product-shot-editing/endpoints/product-lifestyle-shot-by-image`;
	// Campaign
	public static readonly BRIA_API_GEN_FILL: string = `${this.BRIA_API}/image-editing/v2-endpoints/gen_fill`;
	public static readonly BRIA_API_REFLECTIONS: string = `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-generate-reflections`;
	public static readonly BRIA_API_EFFECTS: string = `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-apply-effect`;
	public static readonly BRIA_API_HARMONIZATION: string = `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-harmonize`;

	private static readonly BRIA_COMFYUI_GIT: string = "https://github.com/Bria-AI/ComfyUI-BRIA-API";
	public static readonly BRIA_API_V2: string = "https://docs.bria.ai/api_v2_live";

	public static readonly BRIA_COMFYUI = {
		GIT: this.BRIA_COMFYUI_GIT,
		README: {
			NODES: `${this.BRIA_COMFYUI_GIT}/blob/main/nodes`,
		},
		NODES: `${this.BRIA_COMFYUI_GIT}/tree/main/nodes`,
		VIDEO_NODES: `${this.BRIA_COMFYUI_GIT}/tree/main/nodes/video_nodes`,
		WORKFLOWS: `${this.BRIA_COMFYUI_GIT}/tree/main/workflows`,
	};

	public static readonly HUGGING_FACE = "https://huggingface.co";

	public static readonly BRIA_BLOG = "https://blog.bria.ai";
	public static readonly KNOWLEDGE = {
		REMOVE_BG: `${this.BRIA_BLOG}/brias-new-state-of-the-art-remove-background-2.0-outperforms-the-competition`,
		ERASER: `${this.BRIA_BLOG}/elevate-your-teams-ai-image-editing-with-brias-eraser-0`,
	};
	public static readonly FIBO_GITHUB = "https://github.com/Bria-AI/FIBO";
	public static readonly FIBO_EDIT_GITHUB = "https://github.com/Bria-AI/Fibo-Edit";
	public static readonly FIBO_LITE_GITHUB = "https://github.com/Bria-AI/fibo-container";

	public static readonly MODELS = {
		HUGGING_FACE: this.HUGGING_FACE,
		FOUNDATION: {
			"3_2": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.2`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.2-API`,
				},
			},
			"3_1": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.1`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.1`,
				},
			},
			"4B_ADAPT": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-4B-Adapt`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-4B-Adapt`,
				},
			},
			"2_3": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-BETA`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3`,
				},
			},
			"2_2_HD": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.2-HD`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.2-HD`,
				},
			},
			"2_3_FAST": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-FAST`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-FAST`,
				},
			},
			"2_3_INPAINTING": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-Inpainting`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-Inpainting`,
				},
			},
			FIBO: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/FIBO`,
				},
				DEMO: `${RouterConstants.LABS.FIBO.fullPath}`,
				GITHUB: `${this.FIBO_GITHUB}`,
			},
			FIBO_LITE: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/Fibo-lite`,
				},
				DEMO: `${RouterConstants.LABS.FIBO_LITE.fullPath}`,
				GITHUB: `${this.FIBO_GITHUB}`,
			},
			FIBO_EDIT: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/Fibo-Edit`,
				},
				DEMO: `${RouterConstants.LABS.FIBO_EDIT.fullPath}`,
				GITHUB: `${this.FIBO_EDIT_GITHUB}`,
			},
		},
		AUXILIARY: {
			BRIA3_2_UNION: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.2-ControlNet-Union`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.2-ControlNet-Union`,
				},
			},
			BRIA3_1_UNION: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-3.1-ControlNet-Union`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-3.1-ControlNet-Union`,
				},
			},
			"4B_UNION": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-4B-Adapt-ControlNet-Union`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-4B-Adapt-ControlNet-Union`,
				},
			},
			REMOVE_BG: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/RMBG-2.0`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-RMBG-2.0`,
				},
			},
			"2_3_FAST_LORA": {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-FAST-LORA`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-FAST-LORA`,
				},
			},
			IMAGE_PROMPT: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/Image-Prompt`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/Image-Prompt`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/Image-Prompt`,
				},
			},
			IP_ADAPTER: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ID_Preservation#bria-23-id-preservation-adapter`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/ID_preservation_auraFace`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/ID_preservation_auraFace`,
				},
			},
			GEN_FILL: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Generative-Fill`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Generative-Fill-API`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Generative-Fill-API`,
				},
			},
			REPLACE_BG: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-BG-Gen`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Background-Generation`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/BRIA-Background-Generation`,
				},
			},
			INPAINTING: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/DEV-ControlNetInpaintingFast`,
					DEMO: `${this.HUGGING_FACE}/briaai/DEV-ControlNetInpaintingFast`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/DEV-ControlNetInpaintingFast`,
				},
			},
			CANNY: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Canny`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Canny`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Canny`,
				},
			},
			DEPTH: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Depth`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Depth`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Depth`,
				},
			},
			POSE: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Pose`,
					DEMO: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-ControlNet-Pose`,
					TUTORIAL: `${this.HUGGING_FACE}/spaces/briaai/BRIA-2.3-ControlNet-Pose`,
				},
			},
			RECOLOR: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Recoloring`,
					DOWNLOAD: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Recoloring`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-Recoloring`,
				},
			},
			COLORGRID: {
				HUGGING_FACE: {
					MODEL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-ColorGrid`,
					DEMO: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-ColorGrid`,
					TUTORIAL: `${this.HUGGING_FACE}/briaai/BRIA-2.3-ControlNet-ColorGrid`,
				},
			},
			INCREASE_RES: {
				HUGGING_FACE: {},
			},
		},
	};

	public static readonly IMAGE_GENERATION = {
		OVERVIEW: `${this.BRIA_API}/image-generation`,
		V2: {
			GENERATE_IMAGE: {
				DOCS: `${this.BRIA_API}/image-generation/v2-endpoints/image-generate`,
				COMFY_UI: {
					NODE: `${this.BRIA_COMFYUI.NODES}/generate_image_node_v2.py`,
				},
			},
			GENERATE_IMAGE_PRO: {
				DOCS: `${this.BRIA_API}/image-generation/v2-endpoints/image-generate`,
			},
			STRUCTURED_PROMPT_GENERATE: {
				DOCS: `${this.BRIA_API}/image-generation/v2-endpoints/structured-prompt-generate`,
				COMFY_UI: {
					NODE: `${this.BRIA_COMFYUI.NODES}/generate_structured_prompt_node_v2.py`,
				},
			},
			STRUCTURED_PROMPT_GENERATE_PRO: {
				DOCS: `${this.BRIA_API}/image-generation/v2-endpoints/structured-prompt-generate`,
			},
			GENERATE_IMAGE_LITE: {
				DOCS: `${this.BRIA_API}/image-generation/v2-endpoints/image-generate-lite`,
				COMFY_UI: {
					NODE: `${this.BRIA_COMFYUI.NODES}/generate_image_lite_node_v2.py`,
				},
			},
			STRUCTURED_PROMPT_GENERATE_LITE: {
				DOCS: `${this.BRIA_API}/image-generation/v2-endpoints/structured-prompt-generate-lite`,
				COMFY_UI: {
					NODE: `${this.BRIA_COMFYUI.NODES}/generate_structured_prompt_lite_node_v2.py`,
				},
			},
		},
		BASE: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-image-base`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/text_2_image_base_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_to_image_workflow.json`,
			},
		},
		FAST: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-image-fast`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/text_2_image_fast_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_to_image_workflow.json`,
			},
		},
		HD: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-image-hd`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/text_2_image_hd_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_to_image_workflow.json`,
			},
		},
		FIBO: {
			DOCS: "https://docs.bria.ai/image-generation/v2-endpoints",
		},
		REIMAGINE: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/reimagine-structure-reference`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/reimagine_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/text_2_image_base_node.py`,
			},
		},
		VECTOR_BASE: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-vector-base`,
		},
		VECTOR_FAST: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/text-to-vector-fast`,
		},
		PROMPT_ENHANCEMENT: {
			DOCS: `${this.BRIA_API}/image-generation/endpoints/prompt-enhancer`,
		},
	};

	public static readonly IMAGE_EDITING = {
		OVERVIEW: `${this.BRIA_API}/image-editing`,
		FIBO: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints`,
		},
		GEN_FILL: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/gen_fill`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/generative_fill_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/eraser_genfill_workflow.json`,
			},
		},
		ERASER: {
			DOCS: `${this.BRIA_API}/image-editing/editing/erase`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/eraser_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/eraser_genfill_workflow.json`,
			},
		},
		ERASE_FOREGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/erase_foreground`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/remove_foreground_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/eraser_genfill_workflow.json`,
			},
		},
		REPLACE_BACKGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/replace_background`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/replace_bg_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/background_generation_workflow.json`,
			},
		},
		REMOVE_BACKGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/editing/background-remove`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/rmbg_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/background_generation_workflow.json`,
			},
		},
		BLUR_BACKGROUND: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/blur_background`,
		},
		EXPAND_IMAGE: {
			DOCS: `${this.BRIA_API}/image-editing/editing/image-expansion`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/image_expansion_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/background_generation_workflow.json`,
			},
		},
		INCREASE_RESOLUTION: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/increase_resolution`,
		},
		IMAGE_TO_PSD: {
			DOCS: `${this.BRIA_API}/image-editing/v1-endpoints/image-to-psd`,
		},
		CROP: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/crop_foreground`,
		},
		MODIFY_PRESENTER: {
			DOCS: `${this.BRIA_API}/image-editing/v1-endpoints/create`,
		},
		MASK_GENERATOR: {
			DOCS: `${this.BRIA_API}/image-editing/v1-endpoints/objects-mask-generator`,
		},
		ENHANCE_IMAGE: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/enhance`,
		},
		ADD_OBJECT: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/add-object-by-text`,
		},
		REPLACE_OBJECT: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/replace-object-by-text`,
		},
		ERASE_OBJECT: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/erase-object-by-text`,
		},
		IMAGE_BLENDING: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/blend-image`,
		},
		REWRITE: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/rewrite`,
		},
		RESTYLE: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/restyle`,
		},
		RELIGHT: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/relight`,
		},
		RESEASON: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/reseason`,
		},
		SKETCH_TO_IMAGE: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/sketch-to-image`,
		},
		RESTORE: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/restore`,
		},
		COLORIZE: {
			DOCS: `${this.BRIA_API}/image-editing/v2-endpoints/colorize`,
		},
	};

	public static readonly TG = {
		OVERVIEW: `${this.BRIA_API}/tailored-generation`,
		CREATE_PROJECT: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/create-project`,
		},
		CREATE_DATASET: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/create-dataset`,
		},
		TRAINING: {
			DOCS: `${this.BRIA_API}/tailored-generation/section/training-process`,
		},
		TRAIN_MODEL: {
			DOCS: `${this.BRIA_API}/tailored-generation/section/training-endpoints/start-training`,
		},
		GENERATION: {
			DOCS: `${this.BRIA_API}/tailored-generation/generation-endpoints`,
		},
		GENERATE_IMAGES: {
			DOCS: `${this.BRIA_API}/tailored-generation/image-generation-endpoints`,
		},
		VIDEO_GENERATION: {
			DOCS: `${this.BRIA_API}/tailored-generation/video-generation-endpoints`,
		},
		DOWNLOAD_MODEL: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/download-tailored-model`,
		},
		UPLOAD_MODEL: {
			DOCS: `${this.BRIA_API}/tailored-generation/training-endpoints/upload-model`,
		},
		RESTYLE_PORTRAITS: {
			DOCS: `${this.BRIA_API}/tailored-generation/generation-endpoints/restyle-portrait`,
		},
	};

	public static readonly ADS_GENERATION = {
		OVERVIEW: `${this.BRIA_API}/ad-generation`,
		GET_BRANDS: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/get-brands`,
		},
		GET_TEMPLATES: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/get-templates`,
		},
		GET_TEMPLATE: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/get-template-by-id`,
		},
		GENERATE_CAMPAIGN: {
			DOCS: `${this.BRIA_API}/ad-generation/endpoints/generate-campaign`,
		},
	};

	public static readonly PRODUCT_SHOT = {
		OVERVIEW: `${this.BRIA_API}/product-shot-editing`,
		EMBEDDING: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-integrate`,
		},
		CUTOUT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-cutout`,
		},
		PACKSHOT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-packshot`,
		},
		ADD_SHADOW: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-shadow`,
		},
		LIFESTYLE_BY_TEXT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-lifestyle-shot-by-text`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/shot_by_text_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/product shot generation_workflow.json`,
			},
		},
		LIFESTYLE_BY_IMAGE: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/product-lifestyle-shot-by-image`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.NODES}/shot_by_image_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/product shot generation_workflow.json`,
			},
		},
		BRANDING: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/consistent-product-shots`,
		},
		KEYWORD_EXTRACT: {
			DOCS: `${this.BRIA_API}/product-shot-editing/product-endpoints/contextual-keyword-extraction`,
		},
		AUTOMOTIVE: {
			HARMONIZATION: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/harmonization`,
			},
			REFLECTIONS: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-generate-reflections`,
			},
			SEGMENT_VEHICLE: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-segmentation`,
			},
			VEHICLE_BY_TEXT: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-shot-by-text`,
			},
			VISUAL_EFFECT: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-apply-effect`,
			},
			WHEELS: {
				DOCS: `${this.BRIA_API}/product-shot-editing/automotive-endpoints/vehicle-refine-tires`,
			},
		},
	};

	public static readonly VIDEO_EDITING = {
		OVERVIEW: `${this.BRIA_API}/video-editing`,
		ERASER: {
			DOCS: `${this.BRIA_API}/video-editing/editing-endpoints/erase-object`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.VIDEO_NODES}/video_erase_elements_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/Video_Editig_Workflow.json`,
			},
		},
		REPLACE_BACKGROUND: {
			DOCS: `${this.BRIA_API}/video-editing/editing-endpoints/remove-background`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.VIDEO_NODES}/video_solid_color_background_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/Video_Editig_Workflow.json`,
			},
		},
		REMOVE_BACKGROUND: {
			DOCS: `${this.BRIA_API}/video-editing/editing-endpoints/remove-background`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.VIDEO_NODES}/remove_video_background_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/Video_Editig_Workflow.json`,
			},
		},
		INCREASE_RESOLUTION: {
			DOCS: `${this.BRIA_API}/video-editing/editing-endpoints/increase-resolution`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.VIDEO_NODES}/video_increase_resolution_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/Video_Editig_Workflow.json`,
			},
		},
		MASK_BY_PROMPT: {
			DOCS: `${this.BRIA_API}/video-editing/masking-endpoints/mask-by-prompt`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.VIDEO_NODES}/video_mask_by_prompt_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/Video_Editig_Workflow.json`,
			},
		},
		MASK_BY_KEY_POINTS: {
			DOCS: `${this.BRIA_API}/video-editing/masking-endpoints/mask-by-key-points`,
			COMFY_UI: {
				NODE: `${this.BRIA_COMFYUI.VIDEO_NODES}/video_mask_by_key_points_node.py`,
				WORKFLOW: `${this.BRIA_COMFYUI.WORKFLOWS}/Video_Editig_Workflow.json`,
			},
		},
	};

	public static readonly INTEGRATIONS = {
		HUGGING_FACE: `${this.HUGGING_FACE}/briaai`,
		COMFY_UI: this.BRIA_COMFYUI_GIT,
		FAL: "https://fal.ai/explore/search?q=bria",
		INVOKE: "https://www.invoke.com/",
		FIGMA: RouterConstants.NEW_TG.ACCESS_METHODS.fullPath,
		PHOTOSHOP: RouterConstants.NEW_TG.ACCESS_METHODS.fullPath,
		AWS: "https://aws.amazon.com/marketplace/seller-profile?id=seller-ilfk2fw5juhfi",
		AZURE: "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/briaartificialintelligenceltd1704805814390.bria_image_generation_model_offer?tab=Overview",
		COPILOT: "",
		POWERPOINT: "",
		REPLICATE: "https://replicate.com/bria",
		GITHUB: "https://github.com/Bria-AI",
		API: "https://docs.bria.ai/",
		IFRAME: "https://github.com/Bria-AI/iframe-doc/tree/iframe-v2",
		IMAGE_EDITING_FAL: "https://fal.ai/models/fal-ai/bria/background/replace",
		IMAGE_GENERATION_FAL: "https://fal.ai/models/bria/text-to-image/3.2",
		PRODUCT_SHOT_FAL: "https://fal.ai/models/fal-ai/bria/product-shot",
		DEEPINFRA: "https://deepinfra.com/models?q=bria",
		SEGMIND: "https://www.segmind.com/models?search=bria",
	};
	public static readonly BRIA_COOKBOOK: string = "https://bria.ai/bria-cookbook";

	public static readonly BRIA_CONTACT_US_MFA: string = "https://bria.ai/contact-us?interested_in=Support";

	public static readonly BRIA_CONTACT_US_FOUNDATION_MODELS =
		"https://bria.ai/contact-us?interested_in=Access%20to%20foundation%20models";
	public static readonly ADOBE_MARKETPLACE: string =
		"https://adobe.com/go/cc_plugins_discover_plugin?pluginId=92224702&workflow=share";
	public static readonly BRIA_FIGMA_PLUGIN: string = "https://www.figma.com/community/plugin/1541740878931198133";
	public static readonly BRIA_ATTRIBUTION_SERVICE_DOCS: string = "https://github.com/Bria-AI/bria-attribution";
	public static readonly BRIA_ATTRIBUTION_SERVICE_DOCS_BY_IMAGE: string =
		"https://docs.bria.ai/bria-attribution-service/other/postattributionbyimage ";
	public static readonly BRIA_ATTRIBUTION_SERVICE_DOCS_BY_EMBEDDING: string =
		"https://docs.bria.ai/bria-attribution-service/other/postattributionbyembedding ";
	public static readonly BRIA_FIBO_RESEARCH_PAPER: string = "https://arxiv.org/abs/2511.06876";

	// NEW PLATFORM SANDBOXES
	public static readonly BRIA_NEW_PLATFORM_BACKGROUND_REMOVE_SANDBOX: string = `${ENV_VARS.VITE_NEW_PLATFORM_URL}/image-editing/remove-background/sandbox`;
	public static readonly BRIA_NEW_PLATFORM_INCREASE_RESOLUTION_SANDBOX: string = `${ENV_VARS.VITE_NEW_PLATFORM_URL}/image-editing/increase-resolution/sandbox`;
	public static readonly BRIA_NEW_PLATFORM_EXPAND_IMAGE_SANDBOX: string = `${ENV_VARS.VITE_NEW_PLATFORM_URL}/image-editing/expand-image`;
	public static readonly BRIA_NEW_PLATFORM_ENHANCE_IMAGE_SANDBOX: string = `${ENV_VARS.VITE_NEW_PLATFORM_URL}/image-editing/enhance-image/sandbox`;
}

export default LinkConstants;
